module.exports = __webpack_public_path__ + "static/media/coins.215bbb00.png";